import axios from 'axios';
import { currentUser, Names, history, api } from 'Utils';

const baseURL = 'https://admin.shahrstory.ir/api/app/v1';
const instance = axios.create({
	baseURL
});

instance.interceptors.request.use((config) => {
	const token = currentUser.getToken();
	config.headers.Authorization = token ? `Bearer ${token}` : '';
	return config;
});

instance.interceptors.response.use(
	(res) => {
		return res;
	},
	async (error) => {
		const { status } = error.response;
		const originalConfig = error.config;
		// console.log('originalConfig: ', originalConfig);

		if (status === 401 && !originalConfig._retry) {
			originalConfig._retry = true;
			const token = currentUser.getToken();
			if (token) {
				const token_expire_time = currentUser.getTokenExpireTime();
				const now = Math.ceil(Date.now() / 1000);
				if (token_expire_time > now) {
					//if refresh token exists in local storage proceed
					try {
						//try refreshing token
						// console.log('token: ', token);
						// error.config.headers.Authorization = `Bearer ${token}`;
						const { data } = await axios({
							method: 'post',
							url: baseURL + api.refreshToken,
							headers: { Authorization: `Bearer ${token}` }
						});
						// console.log('accessToken data: ', data);
						let accessToken = data.result.token;
						if (accessToken) {
							//if request is successful and token exists in response
							//store it in local storage
							currentUser.setToken(accessToken);
							//with new token retry original request
							error.config.headers.Authorization = `Bearer ${accessToken}`;
							return instance(error.config);
						}
					} catch (e) {
						return Promise.reject(e);
					}
				} else {
					history.push(Names.login.path);
					currentUser.resetUser();
				}
			}
		} else {
			history.push(Names.login.path);
			currentUser.resetUser();
			return Promise.reject(error);
		}
		if (status === 404) {
			history.push(Names.notfound.path);
			currentUser.resetUser();
		}
	}
);

export default instance;
